import { render, staticRenderFns } from "./Vessel.vue?vue&type=template&id=87fbf512&scoped=true"
import script from "./Vessel.vue?vue&type=script&lang=js"
export * from "./Vessel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fbf512",
  null
  
)

export default component.exports